export default function Footer() {
  return (
    <footer className="mt-auto pt-10 ml-5 border-t border-gray-100 max-w-2xl">
      <p className="m-0 text-xs text-gray-500 leading-relaxed font-normal">
        <span className="font-medium">
          © {new Date().getFullYear()} Nathan Portelli
        </span>
        {" • "}
        <span className="font-normal">
          developed by{" "}
          <a
            href="https://marcfinger.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 no-underline transition-colors duration-200 hover:text-gray-600 font-normal text-xs"
          >
            Marc Finger
          </a>
        </span>
      </p>
    </footer>
  );
}
